// extracted by css-extract-rspack-plugin
export default {"container":"gQCNFDh8","subtitle":"DqP3OSiT","disabled":"_Wg9Tn2P","textContent":"UY568oFX","topTextContent":"IHpWs6eD","icon":"WkeciO9E"};